var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'sidebar-logo',
    _vm.logoMode,
    _vm.className,
    { collapse: _vm.isCollapse, fixed: _vm.fixed }
  ]},[_c('transition',{attrs:{"name":"sidebarLogo"}},[_c('router-link',{staticClass:"flexC",attrs:{"to":_vm.toPath}},[(_vm.logo)?_c('img',{staticClass:"logo flex-1",attrs:{"src":_vm.logo}}):_vm._e(),(_vm.isPng(_vm.logoName))?[(_vm.logoName && (_vm.logoMode !== 'fold' || !_vm.isCollapse))?_c('img',{staticClass:"logo-name flex-1",attrs:{"src":_vm.logoName}}):_vm._e()]:[(_vm.logoName && (_vm.logoMode !== 'fold' || !_vm.isCollapse))?_c('p',{staticClass:"logo-name flex-1"},[_vm._v(" "+_vm._s(_vm.logoName)+" ")]):_vm._e()]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }